import React, { FC } from 'react';
import styled from 'styled-components';

interface FontIconProps {
  name: string;
  color?: string;
  size?: number;
  fill?: boolean;
  weight?: number;
  grad?: number;
  opsz?: number;
  className?: string;
  id?: string;
}

const StyledIcon = styled.span<{
  $color?: string;
  $size?: number;
  $fill?: boolean;
  $weight?: number;
  $grad?: number;
  $opsz?: number;
}>`
  font-family: 'Google Symbols';
  font-style: normal;
  font-size: ${({ $size }) => $size ?? 24}px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
  color: ${({ $color }) => $color ?? 'inherit'};

  /* Support variable font features if the browser supports them */
  font-variation-settings:
    'FILL' ${({ $fill }) => ($fill ? 1 : 0)},
    'wght' ${({ $weight }) => $weight ?? 400},
    'GRAD' ${({ $grad }) => $grad ?? 0},
    'opsz' ${({ $opsz, $size }) => $opsz ?? $size ?? 24};
`;

export const FontIcon: FC<FontIconProps> = ({
  name,
  color,
  size,
  fill,
  weight,
  grad,
  opsz,
  className,
  id,
}) => {
  return (
    <StyledIcon
      id={id}
      className={`google-symbols ${className ?? ''}`}
      $color={color}
      $size={size}
      $fill={fill}
      $weight={weight}
      $grad={grad}
      $opsz={opsz}
    >
      {name}
    </StyledIcon>
  );
};

export default FontIcon;
